import React, { use, useEffect, useState } from 'react'
import { Badge, Button, Card, Col, Form, ListGroup, Modal, Nav, Row, Table } from 'react-bootstrap'
import Avatar from '../Avatar'
import img10 from '../../assets/img/img10.jpg'
import VisitModal from '../modals/VisitModal'
import { Link } from 'react-router-dom'
import useManageDashboardOverview from '../../hooks/patientDashboard/usemanageDashboardData'
import moment from "moment";
import Spinner1 from '../common/spinners'
import useManageDrugs from '../../hooks/patientDashboard/useMangeDrugs'
import ScaleLoader from 'react-spinners/ScaleLoader'
import { User, User2, UserCircle } from 'lucide-react'
import ConfirmationModal from '../modals/ConfirmationModal'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import useManageAppointment from '../../hooks/patientDashboard/useManageAppointment'
import { toast } from 'sonner'
import Updates from '../card/updates'
import ProfileModal from '../modals/profileModal'
import useProfileStore from '../../store/patient/profileStore'
import { useDashboard } from '../../context/dashboardContext'

const ProfileViewTab = () => {
  const [show, setShow] = React.useState(false)
  // const [confirmModal, setConfirmModal] = useState(false)
  // const [showDetailsModal, setShowDetailsModal]= useState(false)
  const [rescheduleDate, setRescheduleDate] = useState("")
  const [rescheduleTime, setRescheduleTime] = useState("")
  const [rescheduleReason, setRescheduleReason] = useState("")
  const [selectedAppointment, setSelectedAppointment] = useState()
  const {profile} = useProfileStore();
  const {
        doctorsWithAppointments,
        setDoctorsWithAppointments,
        handleFetchDoctorsWithAppointment} = useDashboard();



        console.log(doctorsWithAppointments,"================================ doctors")
  
  const OpenModal = () => {
    setShow(true)
  }

  const {appointments, handleFetchVitals,showDetailsModal, setShowDetailsModal,loading, transactions,confirmModal, setConfirmModal,handleReScheculeAppointment,handleCancelAppointment, handleFetchTransactions,handleFetAppointments} = useDashboard()
  // const {handleReScheculeAppointment}= useManageAppointment()

  const {drugs,loading:loadingDrugs, handleFetchDrugs} = useManageDrugs();

 

  useEffect(() => {
    handleFetchDrugs()
    handleFetAppointments();
    handleFetchTransactions();
    handleFetchDoctorsWithAppointment();
  }, [])
  
  console.log(profile)

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return {
      day: date.toLocaleDateString("en-US", { weekday: "short" }),
      num: date.getDate().toString().padStart(2, "0"),
      time: date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      })
    };
  };

  const handleCancelApp = () =>{
    handleCancelAppointment(selectedAppointment?.id)
  }


  // const groupedTransactions = [transactions]?.reduce((acc, transaction) => {
  //   const formattedDate = moment(transaction?.createdAt).format("dddd, MMMM D");
  //   if (!acc[formattedDate]) acc[formattedDate] = [];
  //   acc[formattedDate]?.push(transaction);
  //   return acc;
  // }, {});

  const RSData = {
    "appointment_date":rescheduleDate,
    "id":selectedAppointment?.id,
    "description":rescheduleReason,
    "duration":rescheduleTime,
    "duration_type":selectedAppointment?.duration_type

  }
  
const handleReschedule = () =>{
  handleReScheculeAppointment(RSData).then((res)=>{
    toast.success("Appoinment Reshedulled succesfully")
    handleFetAppointments()
    
  })
 
}
const upcomingAppointment = appointments
  ?.filter(x =>
    x?.status !== "Cancelled" &&
    moment(x?.appointment_date).isAfter(moment())
  )
  ?.sort((a, b) =>
    moment(a.appointment_date).diff(moment(b.appointment_date))
  )
  ?.slice(0, 1);


// console.log(selectedAppointment,'selected appountment')
console.log(appointments,'appointments')
  return (
    <>
      <div className="divider divider-start fw-medium mx-3">
        <span>Overview</span>
      </div>
      <Row className="my-3">
        <Col>
         <Updates/>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card className="card-one">
            <Card.Header>
            Next Appointment
            </Card.Header>
            <Card.Body className='d-flex flex-column gap-4'>
            {loading ? <div className=' w-100 d-flex justify-content-center'><Spinner1/></div> :
           <div>
            {loading ? (
         <div className="w-100 d-flex justify-content-center"><Spinner1 /></div>
              ) : (
                <div>
                  {upcomingAppointment?.filter((x)=>x?.status !=="Cancelled")?.map((appointment) => (
                    <div key={appointment.id}>
                      <ul className="people-group">
                        <li className="people-item align-items-center d-flex p-0 text-capitalize mr-2">
                          {appointment.whomToSee?.profile_pic ? (
                            <Avatar img={appointment.whomToSee?.profile_pic || "#"} />
                          ) : (
                            <p className="text-success me-2"><UserCircle /></p>
                          )}
                          <div className="people-body">
                            <h6><Link to="">{appointment?.whomToSee?.first_name || '--'} {appointment?.whomToSee?.last_name ?? '--'}</Link></h6>
                            <span>{appointment.whomToSee?.profession}</span>
                          </div>
                        </li>
                      </ul>
                      <div>
                        <ul className="people-group">
                          <li className="people-item px-0">
                            <div className="people-body">
                              <h6 className="text-success fs-sm">Date</h6>
                              <span>{moment(appointment?.appointment_date).format("dddd, Do MMM YYYY")}</span>
                            </div>
                            <div className="text-end">
                              <div className="text-success fs-sm">Time</div>
                              <span className="d-block fs-xs text">
                                {new Date(appointment.appointment_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                              </span>
                            </div>
                          </li>
                        </ul>
                        <ul className="people-group">
                          <li className="people-item px-0">
                            <div className="people-body">
                              <h6 className="text-success">Address</h6>
                              {appointment?.is_online ? 'Virtual Presentation' : 'Physical Consultation'}
                            </div>
                            <div className="text-end">
                              <div className="text-success">Type</div>
                              <span className="d-block fs-xs text">{appointment?.consultation_type || '---'}</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="product-review-footer d-flex align-items-center">
                        <Link to=""><i className="ri-thumb-up-line text-success"></i></Link>
                        <h6
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setShowDetailsModal(true);
                            setSelectedAppointment(appointment);
                          }}
                          className="m-0 fs-sm"
                        >
                          Reschedule booking
                        </h6>
                        <div className="divider divider-vertical fw-medium">|</div>
                        <Link to=""><i className="ri-thumb-down-line text-success"></i></Link>
                        <h6
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            if (appointment?.transaction?.status !== 1) {
                              setConfirmModal(true);
                              setSelectedAppointment(appointment);
                            }else{
                              toast.error("Appointment cannot be cancelled")
                            }
                          }}
                          className="m-0 fs-sm"
                        >
                          Cancel booking
                        </h6>
                      </div>
                    </div>
                  ))}

                  {/* Show "No record found" if no future appointments */}
                  {appointments?.filter((x) => 
                    x?.status !== "Cancelled" && moment(x?.appointment_date).isAfter(moment())
                  ).length === 0 && (
                    <div className="text-center text-muted">No upcoming appointment</div>
                  )}
                </div>
              )}

           </div>
            }
          </Card.Body>

          </Card>
        </Col>
        <Col lg="6">
          <Card className="card-one">
            <Card.Header>
             Upcoming Appointments
            </Card.Header>
            <Card.Body className="p-3">
            <ul className="events-list">
              { loading? <div className=' w-100 d-flex justify-content-center'><Spinner1/></div> : appointments?.filter((x)=>x?.status !="Cancelled"&& moment(x?.appointment_date).isAfter(moment()))?.length > 0 ?
              <div>
                {
                  appointments?.filter((x)=>x?.status !="Cancelled"&& moment(x?.appointment_date).isAfter(moment())
                )?.slice(0,3)?.map((appointment, index) => {
                    const formattedDate = formatDate(appointment.appointment_date);
                    return (
                      <li key={index}>
                        <div className="event-date">
                          <small>{formattedDate.day}</small>
                          <h5>{formattedDate.num}</h5>
                        </div>
                        <div className="events-body">
                          <div className="ev-item">
                            <small>{formattedDate.time}</small>
                            <h6>{appointment.description}</h6>
                            {/* <p>
                              Patient: {appointment.patient.surname} {appointment.patient.other_names}
                            </p> */}
                            <small>
                              Doctor: {appointment?.whomToSee?.first_name || '--'} {appointment?.whomToSee?.last_name ?? '--'}
                            </small>
                          </div>
                        </div>
                      </li>
                    );
                  })
                }
              </div>
              :<div>No Records Found</div>
              }
            </ul>
    </Card.Body>
          </Card>
        </Col>
      </Row>
      <div className={"divider divider-start fw-medium"}>
        <span>Recent Activity</span>
      </div>
      <Row>
        <Col lg="6" className=''>
        <Card className='mb-2'><Card.Header>Recent Prescriptions</Card.Header></Card>
            {
              loading ? <div className=' w-100 d-flex justify-content-center'><Spinner1/></div> :

              <div>

                {
                  loadingDrugs ? <div className=' d-flex w-100 justify-content-center'><Spinner1/></div> :
                      drugs?.result?.length > 0 ? 
                      drugs?.result?.slice(0,2)?.map((item)=>(
                        <Card className="card-task">
                      <Card.Body className="p-3 pb-1">
                        <div className="d-flex gap-1">
                        {item?.admission &&(<Badge bg={"success"}>Admission</Badge>)}
                        {item?.requests[0]?.item?.refills > 0 ?<Badge bg={"primary"}>Refillable</Badge>:<Badge bg={"primary"}>Non-Refillable</Badge>}
                        </div>
                        <div className="d-flex flex-row-reverse align-items-center justify-content-between mt-2 mb-1">
                          <span className="card-date">{moment(item?.created_at).format("Do MMM YYYY")}</span>
                          <Card.Title as="h6">{item?.requests?.map((x)=>(
                            <span key={x?.id}>{x?.item?.drug?.name || x?.item?.vaccine?.name_of_vaccine}</span>
                          ))}</Card.Title>
                        </div>
                        <p style={{textTransform:'capitalize'}} className="fs-xs">Prescribed by: <Link to="">{item?.created_by}</Link></p>
                        <p className="fs-sm">{item?.requestNote}</p>
                      </Card.Body>
                    </Card>
                      )) :
                    <div>No Records Available</div>
                }
              

              </div>
            }
        </Col>
        <Col lg="6">

          <Card className="card-one">
            <Card.Header>
             Recent Transactions
            </Card.Header>
            <Card.Body>
            <div className={"divider divider-start fw-medium mt-0"}> 
             <span>Today's Transactions</span>
           </div> 
      {loading ? <div className=' w-100 d-flex justify-content-center'><Spinner1/></div> :transactions?.filter((trans) => moment(trans?.createdAt).isSame(moment(), "day"))?.slice(0,1)?.map(( trans, index) => (
        <React.Fragment key={trans?.id}>
         
          <ListGroup as="ul" className="list-group-one">
              <ListGroup.Item  as="li" className="px-0 d-flex align-items-center gap-2">
                <div className={`avatar border border-2 border-primary text-primary`}>
                  <i className="ri-arrow-right-up-line"></i>
                </div>
                <div>
                  <h6 className="mb-0">{trans?.service?.item?.name}</h6>
                  <small>{moment(trans?.createdAt).format("Do MMM YYYY")}</small>
                </div>
                <div className="ms-auto text-end">
                  <h6 className="ff-numerals mb-0">{trans?.amount?.toLocaleString('en-NG', { style: 'currency', currency: 'NGN',})}</h6>
                  <small className={trans?.status === 1 ? "text-success" : "text-danger"}>
                    {trans?.status === 1 ? "Completed" : "Pending"}
                  </small>
                </div>
              </ListGroup.Item>
          </ListGroup>        
        </React.Fragment>
      ))}

<div className={"divider mt-4 divider-start fw-medium" }>
  <span>Previous Transactions</span>
</div>

{transactions?.filter((trans) => moment(trans?.createdAt).isBefore(moment(), "day"))?.slice(0,2)?.map(( trans, index) => (
        <React.Fragment key={trans?.id}>
          
          <ListGroup as="ul" className="list-group-one">
              <ListGroup.Item  as="li" className="px-0 d-flex align-items-center gap-2">
                <div className={`avatar border border-2 border-primary text-primary`}>
                  <i className="ri-arrow-right-up-line"></i>
                </div>
                <div>
                  <h6 className="mb-0">{trans?.service?.item?.name}</h6>
                  <small>{moment(trans?.createdAt).format("Do MMM YYYY")}</small>
                </div>
                <div className="ms-auto text-end">
                  <h6 className="ff-numerals mb-0">{trans?.amount?.toLocaleString('en-NG', { style: 'currency', currency: 'NGN',}) }</h6>
                  <small className={trans?.status === 1 ? "text-success" : "text-danger"}>
                    {trans?.status === 1 ? "Completed" : "Pending"}
                  </small>
                </div>
              </ListGroup.Item>
          </ListGroup>
          </React.Fragment>))}
    </Card.Body>
          </Card>

        </Col>
      </Row>
      
      <ConfirmationModal
        message="Are you sure you want to Cancel this appointment?"
      show={confirmModal} onConfirm={handleCancelApp} setShow={setConfirmModal}/>

<Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reschedule Appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {selectedAppointment && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>New Date</Form.Label>
                <DatePicker selected={rescheduleDate} onChange={(date) => setRescheduleDate(date)} className="form-control" />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>New Time</Form.Label>
                <Form.Control type="time" value={rescheduleTime} onChange={(e) => setRescheduleTime(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Reason for Rescheduling</Form.Label>
                <Form.Control as="textarea" rows={3} value={rescheduleReason} onChange={(e) => setRescheduleReason(e.target.value)} />
              </Form.Group>
            </>
          )}

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>Close</Button>
          <Button variant="primary" onClick={() => handleReschedule() }>Submit</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ProfileViewTab